module.exports = vendor_6b54c2432e540f8b5919;